var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('UserModal'),_c('UserDetailModal'),_c('page-header',{attrs:{"heading":"User Management","action":"Add","toggle":"offcanvas","target":"#offcanvasCreate","guard":this.$route.meta.guard},on:{"click":function($event){return _vm.setCreateForm()}}}),_c('UserTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }